/* ============ Urino — global.js (vanilla, minimal) ============ */
(function () {
  'use strict';

  /* --- Révélation au défilement --- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (e) { e.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* --- Compte à rebours (persistant, redémarre à expiration) --- */
  function initCountdowns() {
    document.querySelectorAll('[data-countdown-minutes]').forEach(function (el) {
      var mins = parseInt(el.getAttribute('data-countdown-minutes'), 10) || 60;
      var key = 'urino_cd_' + (el.id || 'default');
      var end = parseInt(sessionStorage.getItem(key), 10);
      if (!end || end < Date.now()) {
        end = Date.now() + mins * 60000;
        sessionStorage.setItem(key, String(end));
      }
      var boxes = el.querySelectorAll('[data-cd-unit]');
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var d = Math.max(0, end - Date.now());
        if (d === 0) { end = Date.now() + mins * 60000; sessionStorage.setItem(key, String(end)); }
        var s = Math.floor(d / 1000);
        var vals = { days: Math.floor(s / 86400), hours: Math.floor(s % 86400 / 3600), mins: Math.floor(s % 3600 / 60), secs: s % 60 };
        boxes.forEach(function (b) { b.textContent = pad(vals[b.getAttribute('data-cd-unit')] || 0); });
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* --- Sélecteur d'offres (bundle) : synchronise quantité + formulaire --- */
  function initOffers() {
    var groups = {};
    document.querySelectorAll('[data-offer]').forEach(function (offer) {
      var key = offer.getAttribute('data-offer-form') || 'default';
      (groups[key] = groups[key] || []).push(offer);
    });
    Object.keys(groups).forEach(function (key) {
      var form = document.getElementById(key);
      var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
      var offers = groups[key];
      offers.forEach(function (offer) {
        offer.addEventListener('click', function () {
          offers.forEach(function (o) {
            o.classList.remove('is-selected');
            var r = o.querySelector('input[type="radio"]'); if (r) r.checked = false;
          });
          offer.classList.add('is-selected');
          var radio = offer.querySelector('input[type="radio"]'); if (radio) radio.checked = true;
          if (qtyInput) qtyInput.value = offer.getAttribute('data-qty') || 1;
        });
      });
    });
  }

  /* --- Carrousel simple (témoignages) --- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (c) {
      var track = c.querySelector('[data-carousel-track]');
      var prev = c.querySelector('[data-carousel-prev]');
      var next = c.querySelector('[data-carousel-next]');
      if (!track) return;
      function step() {
        var item = track.querySelector(':scope > *');
        return item ? item.getBoundingClientRect().width + 20 : 320;
      }
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCountdowns();
    initOffers();
    initCarousels();
  });
})();

/* ===== Galerie dynamique : défilement auto + balayage tactile ===== */
(function () {
  function initGalleryAutoplay() {
    document.querySelectorAll('[id^="GalleryMain-"]').forEach(function (main) {
      var gallery = main.closest('.gallery');
      if (!gallery) return;
      var thumbs = gallery.querySelectorAll('.gallery__thumbs button');
      var img = main.querySelector('img');
      if (thumbs.length < 2 || !img) return;
      var idx = 0, timer = null, stopped = false;

      function show(i) {
        idx = (i + thumbs.length) % thumbs.length;
        var t = thumbs[idx];
        img.classList.add('gallery-fade');
        setTimeout(function () {
          img.src = t.querySelector('img').getAttribute('data-full');
          thumbs.forEach(function (b) { b.classList.remove('is-active'); });
          t.classList.add('is-active');
          img.classList.remove('gallery-fade');
        }, 220);
      }
      function start() { if (!stopped && !timer) timer = setInterval(function () { show(idx + 1); }, 3500); }
      function stop() { clearInterval(timer); timer = null; }
      function userStop() { stopped = true; stop(); }

      main.addEventListener('mouseenter', stop);
      main.addEventListener('mouseleave', function () { if (!stopped) start(); });
      thumbs.forEach(function (b, i) {
        b.addEventListener('click', function () { userStop(); idx = i; });
      });

      var x0 = null;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { userStop(); show(dx < 0 ? idx + 1 : idx - 1); }
        else if (!stopped) start();
        x0 = null;
      }, { passive: true });

      if (!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) start();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGalleryAutoplay);
  else initGalleryAutoplay();
})();